import { appService } from "site/services/app.service";
import {
  authFetch,
  getSessionToken,
  hasBookContentKeyInSession,
  refreshAuthSession,
} from "site/services/auth-session.service";
import { subscriptionApiBaseUrl } from "site/services/xq-api-base-url";
export { subscriptionApiBaseUrl };

export type PaymentRegion = {
  id: string;
  label: string;
  methods: string[];
  owner_only?: boolean;
};

export async function fetchPaymentRegions(): Promise<PaymentRegion[]> {
  const base = subscriptionApiBaseUrl();
  const token = getSessionToken();
  if (!base || !token) {
    return [];
  }
  try {
    const response = await authFetch(`${base}/payment/regions`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      return [];
    }
    const data = (await response.json()) as { regions?: PaymentRegion[] };
    if (!Array.isArray(data.regions)) {
      return [];
    }
    return data.regions.filter(
      (region) =>
        region &&
        typeof region.id === "string" &&
        region.id.trim() !== "" &&
        typeof region.label === "string",
    );
  } catch {
    return [];
  }
}

export async function grantEditorFreeSubscription(bookId: number): Promise<void> {
  const base = subscriptionApiBaseUrl();
  const token = getSessionToken();
  if (!base || !token) {
    throw new Error("no session");
  }
  const response = await authFetch(`${base}/editor/subscriptions/grant-free`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ book_id: bookId }),
  });
  if (!response.ok) {
    const detail = await response.text().catch(() => "");
    throw new Error(detail || `grant free subscription: HTTP ${response.status}`);
  }
}

export async function tryRefreshBookAccessAfterPayment(bookId: string): Promise<boolean> {
  const bid = `${bookId}`;
  if (!bid || !subscriptionApiBaseUrl() || !getSessionToken()) {
    return false;
  }
  try {
    await refreshAuthSession();
  } catch {
    return false;
  }
  if (!hasBookContentKeyInSession(bid)) {
    return false;
  }
  appService.notifySubscriptionAccessChanged();
  return true;
}
